/**
 * IosToggle — interruptor réplica del UISwitch de iOS.
 * Verde #34C759 en ON, gris sólido en OFF, perilla blanca con sombra iOS.
 *
 * Uso:
 *   <IosToggle checked={valor} onChange={setValor} testid="mi-toggle" />
 */
export default function IosToggle({ checked, onChange, testid, disabled }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!checked}
      data-testid={testid}
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        onChange?.(!checked);
      }}
      className="relative flex-shrink-0 disabled:opacity-50"
      style={{
        width: 60,
        height: 35,
        borderRadius: 999,
        background: checked ? "#34C759" : "#3A3A3F",
        border: "none",
        padding: 0,
        cursor: "pointer",
        WebkitTapHighlightColor: "transparent",
        transition: "background-color 0.25s ease",
        boxShadow: checked
          ? "none"
          : "inset 0 0 0 1px rgba(255,255,255,0.08)",
      }}
    >
      <span
        style={{
          position: "absolute",
          top: 3,
          left: checked ? 28 : 3,
          width: 29,
          height: 29,
          borderRadius: "50%",
          background: "#FFFFFF",
          transition: "left 0.25s cubic-bezier(0.3, 1.2, 0.4, 1)",
          boxShadow:
            "0 3px 8px rgba(0,0,0,0.35), 0 1px 2px rgba(0,0,0,0.25)",
        }}
      />
    </button>
  );
}
